module.exports = __webpack_public_path__ + "static/media/pointshound_miles_teal.fe959679.svg";